export default __webpack_public_path__ + "static/media/007-wireless mouse.ff7faf79.svg";